import { cva, type VariantProps } from 'class-variance-authority'
import type { LucideProps } from 'lucide-react'
import type { ForwardRefExoticComponent, RefAttributes } from 'react'

const iconVariants = cva([], {
    variants: {
        color: {
            primary: ['text-iconPrimary'],
            secondary: ['text-iconSecondary'],
            tertiary: ['text-iconTertiary'],
            onColor: ['text-iconOncolor'],
            disabled: ['text-iconDisabled'],
            negative: ['text-iconNegative'],
            negativeSecondary: ['text-textNegativeSecondary'],
            positive: ['text-iconPositive'],
            warning: ['text-iconWarning'],
            information: ['text-iconInformation'],
            interactive: ['text-iconInteractive'],
            purple: ['text-iconPurple'],
            white: ['text-white']
        }
    },
    defaultVariants: {
        color: 'primary'
    }
})

const _iconSizes = ['1', '2', '3', '4', '5', '6', '7', '8']
type IconSize = (typeof _iconSizes)[number]

export interface IconProps extends Omit<LucideProps, 'color'>, Omit<VariantProps<typeof iconVariants>, 'size'> {
    icon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>
    size?: IconSize
}

const mapSize = (size: IconSize): number => {
    switch (size) {
        case '1':
            return 12
        case '2':
            return 16
        case '3':
            return 20
        case '4':
            return 24
        case '5':
            return 28
        case '6':
            return 32
        case '7':
            return 36
        case '8':
            return 40
        default:
            return 24
    }
}

const Icon = ({ icon, color, size = '2', strokeWidth = 1.2, className, ...props }: IconProps) => {
    const Icon = icon

    return (
        <Icon
            size={mapSize(size)}
            className={iconVariants({
                className,
                color
            })}
            strokeWidth={strokeWidth}
            {...props}
        />
    )
}

export default Icon
